import Datepicker from 'vuejs-datepicker';

//

var script = {
  name: 'PtDatepicker',
  components: { Datepicker: Datepicker },
  props: {
    closeOnRangeSelect: {
      type: Boolean,
      default: false,
    },
    disabledDates: {
      type: Object,
      default: function() {
        return {};
      },
      shape: "\n      {\n        to?: Date, // Disable all dates up to specific date\n        from?: Date, // Disable all dates after specific date\n        days?: Array<DayIndex>, // Disable e.g. Saturday's and Sunday's\n        daysOfMonth?: Array<Day>, // Disable e.g. 29th, 30th and 31st of each month\n        dates?: Array<Date>, // Disable an array of dates\n        ranges?: Array<{ from: Date, to: Date }> // Disable dates in given ranges (exclusive).\n      }",
    },
    format: {
      type: String,
      default: 'dd MMM yyyy',
    },
    inputClass: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'Pick a Date',
    },
    placeholder: {
      type: String,
      default: '',
    },
    range: {
      type: Boolean,
      default: false,
    },
    showNextMonthDates: {
      type: Boolean,
      default: false,
    },
    showPrevMonthDates: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Object, Number, Date],
      default: null,
    },
    weekRange: {
      type: Boolean,
      default: false,
    },
  },
  data: function data() {
    return {
      date: this.value || null,
    };
  },
  watch: {
    value: function value(val) {
      if (!val && this.range) {
        this.date = { from: null, to: null };
      } else {
        this.date = val;
      }
    },
  },
  methods: {
    selectDate: function selectDate(date) {
      this.date = date;
      this.$emit('selected', date);
      this.$emit('input', date);
    },
  },
};

function normalizeComponent(compiledTemplate, injectStyle, defaultExport, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, isShadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof isShadowMode === 'function') {
        createInjectorSSR = createInjector;
        createInjector = isShadowMode;
        isShadowMode = false;
    }
    // Vue.extend constructor export interop
    const options = typeof defaultExport === 'function' ? defaultExport.options : defaultExport;
    // render functions
    if (compiledTemplate && compiledTemplate.render) {
        options.render = compiledTemplate.render;
        options.staticRenderFns = compiledTemplate.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (injectStyle) {
                injectStyle.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (injectStyle) {
        hook = isShadowMode
            ? function () {
                injectStyle.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
            }
            : function (context) {
                injectStyle.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return defaultExport;
}

/* script */
            var __vue_script__ = script;
            
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "pt-datepicker-container" },
    [
      _vm.label ? _c("label", [_vm._v(_vm._s(_vm.label))]) : _vm._e(),
      _vm._v(" "),
      _c(
        "datepicker",
        {
          attrs: {
            "close-on-range-select": _vm.closeOnRangeSelect,
            "disabled-dates": _vm.disabledDates,
            format: _vm.format,
            "input-class": _vm.inputClass,
            "monday-first": false,
            placeholder: _vm.placeholder,
            range: _vm.range,
            "show-next-month-dates": _vm.showNextMonthDates,
            "show-prev-month-dates": _vm.showPrevMonthDates,
            value: _vm.date,
            "week-range": _vm.weekRange
          },
          on: { selected: _vm.selectDate }
        },
        [_vm._t("afterDayPicker", null, { slot: "afterDayPicker" })],
        2
      )
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Datepicker$1 = normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

export { Datepicker$1 as PtDatepicker };
